import { ReactNode } from "react";
import * as S from "./styles";

import { ReactComponent as LocalPin } from "assets/local-pin.svg";
import { ReactComponent as PeoplesSafe } from "assets/SidebarIcons/peoplesafeone.svg";
import { ReactComponent as Car } from "assets/Cards/car.svg";
import { ReactComponent as Home } from "assets/Cards/home.svg";
import { ReactComponent as Shop } from "assets/shop.svg";
import { ReactComponent as PeoplesSafeOffline } from "assets/people-safe-offline.svg";

import { Coords } from "interfaces/Coords";
import { MarkerType } from "../GlobalMap";

export type MapListItemProps = {
  name: string;
  coords: Coords;
  type: MarkerType;
  onPinClick?: (coords: Coords) => void;
};

type IconEnum = {
  [key: string]: ReactNode;
};

function MapListItem({
  name,
  coords,
  type,
  onPinClick = () => {},
}: MapListItemProps) {
  const icons: IconEnum = {
    policeman: <PeoplesSafe />,
    policemanOnDuty: <PeoplesSafeOffline />,
    occVehicle: <Car />,
    occPatrimony: <Home />,
    store: <Shop />,
  };

  return (
    <S.Wrapper>
      <div>
        <S.Badge>{icons[type]}</S.Badge>

        <div>
          <p>{name}</p>
          <span>
            {coords.latitude}, {coords.longitude}
          </span>
        </div>
      </div>

      <S.Button onClick={() => onPinClick(coords)}>
        <LocalPin />
      </S.Button>
    </S.Wrapper>
  );
}

export { MapListItem };
